<template>
  <div>
    <WebHeaderView :title="$t('menu.vip')" />
    <div class="page-content">
      <div class="privileges">
        <div class="group-t">
          <span class="line-left"></span>VIP尊享特权<span
            class="line-right"
          ></span>
        </div>
      </div>
      <div style="margin: 10px">
        <div v-for="(item, index) in vipLis" :key="index">
          <div
            class="vip-box"
            :class="'vip-bg' + (index + 1)"
            v-show="item.id == active"
          >
            <div class="usr-vip open">
              {{ item.vip_id <= userInfo.vip ? '已解锁' : '未解锁' }}
            </div>
            <div
              style="
                font-size: 48px;
                font-weight: 600;
                color: #fff;
                position: absolute;
                top: 40px;
                left: 20px;
              "
            >
              {{ item.vipname }}
            </div>
            <div class="vip-icon">
              <img
                :src="
                  require('../../assets/images/vip/vip_icon_' +
                    (index + 1) +
                    '.webp')
                "
              />
            </div>
            <div
              style="
                border-bottom: 2px solid #e6e6e6;
                width: 90%;
                margin: 0 auto;
                height: 140px;
              "
            ></div>
            <div
              style="
                width: 90%;
                margin: 0 auto;
                color: #fff;
                font-size: 16px;
                height: 48px;
                line-height: 48px;
                display: none;
              "
            >
              已晋级
            </div>
          </div>
        </div>
        <van-tabs
          @click="tabClick"
          v-model="active"
          color="#fff"
          title-active-color="#fff"
          v-if="vipLis && vipLis.length > 0"
        >
          <van-tab
            v-for="(item, index) in vipLis"
            :title="item.vipname"
            :key="index"
            :name="item.id"
          ></van-tab>
        </van-tabs>
      </div>

      <div style="width: 90%; margin: 0px auto;">
        <div v-for="(item, index) in vipLis" :key="index">
          <div v-show="item.id == active">
            <van-row style="text-align: center; line-height: 1.6;min-height: 97px;">
              <van-col :span="8">
                <van-icon name="gold-coin-o" size="24" color="#fff" />
                <p style="font-size: 18px; color: #fff">{{ item.be_promoted_bonus }}</p>
                <p>晋级奖金</p>
                <div style="color:#cca352;border: 1px solid #cca352;width: 80%;margin: 0 auto;" v-if="bonus.filter(e => e.vip_level == item.id && e.bonus_type == 1 && e.status == 0).length > 0 "
                  @click="doBonus(bonus.filter(e => e.vip_level == item.id && e.bonus_type == 1 && e.status == 0)[0])">领取</div>
              </van-col>
              <van-col :span="8">
                <van-icon name="gold-coin-o" size="24" color="#fff" />
                <p style="font-size: 18px; color: #fff">{{ item.week_bonus }}</p>
                <p>周奖金</p>
                <div style="color:#cca352;border: 1px solid #cca352;width: 80%;margin: 0 auto;" 
                v-if="bonus.filter(e => e.vip_level == item.id && e.bonus_type == 2 && e.status == 0).length > 0 "
                @click="doBonus(bonus.filter(e => e.vip_level == item.id && e.bonus_type == 2 && e.status == 0)[0])">领取</div>
              </van-col>
              <van-col :span="8">
                <van-icon name="gold-coin-o" size="24" color="#fff" />
                <p style="font-size: 18px; color: #fff">{{ item.month_bonus }}</p>
                <p>月奖金</p>
                <div style="color:#cca352;border: 1px solid #cca352;width: 80%;margin: 0 auto;" 
                v-if="bonus.filter(e => e.vip_level == item.id && e.bonus_type == 3 && e.status == 0).length > 0 "
                @click="doBonus(bonus.filter(e => e.vip_level == item.id && e.bonus_type == 3 && e.status == 0)[0])">领取</div>
              </van-col>
            </van-row>
            <van-divider />
            <van-row style="color: #fff;font-size: 14px;">
              <van-col :span="7">周奖金存款要求</van-col>
              <van-col :span="5">{{ item.week_deposit }}</van-col>
              <van-col :span="7">月奖金存款要求</van-col>
              <van-col :span="5">{{ item.week_bet }}</van-col>
            </van-row>
            <van-row style="color: #fff;font-size: 14px;">
              <van-col :span="7">周奖金投注要求</van-col>
              <van-col :span="5">{{ item.month_deposit }}</van-col>
              <van-col :span="7">月奖金投注要求</van-col>
              <van-col :span="5">{{ item.month_bet }}</van-col>
            </van-row>
            <van-divider />
          </div>
        </div>
      </div>

      <div v-if="vipLis.length > 0">
        <div v-for="(item, index) in vipLis" :key="index">
          <div data-v-3190160e="" class="_3di95a3H" v-show="item.id == active">
            <div data-v-3190160e="" class="_1HjYPvvp">
              <p data-v-3190160e="">VIP{{ index }}达成及返水比例</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">累计流水</p>
              <p data-v-3190160e="">{{ item.totalgame }} / {{ item.flow }}</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">累计充值</p>
              <p data-v-3190160e="">{{ item.paysum }} / {{ item.recharge }}</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">真人返水</p>
              <p data-v-3190160e="">{{ item.realperson }}%</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">电子返水</p>
              <p data-v-3190160e="">{{ item.electron }}%</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">棋牌返水</p>
              <p data-v-3190160e="">{{ item.joker }}%</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">体育返水</p>
              <p data-v-3190160e="">{{ item.sport }}%</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack">
              <p data-v-3190160e="">彩票返水</p>
              <p data-v-3190160e="">{{ item.lottery }}%</p>
            </div>
            <div data-v-3190160e="" class="_1HjYPvvp returnBack" style="border-bottom: 1px solid #e9edf6">
              <p data-v-3190160e="">电竞返水</p>
              <p data-v-3190160e="">{{ item.e_sport }}%</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/Header/index.vue'
export default {
  name: 'VipView',
  components: { WebHeaderView },
  data () {
    return {
      vipLis: [],
      active: 0,
      bonus: null,
      userInfo: {}
    }
  },
  mounted () {
    this.getusrBonus()
    this.getusrInf()
  },
  methods: {
    tabClick(){},
    async getusrBonus () {
      await this.$http({
        method: 'get',
        url: 'userBonus'
      }).then(data => {
        this.bonus = data.data
        this.getusrVip()
      })
    },
    async doBonus (item) {
      await this.$http({
        method: 'get',
        url: 'doUserBonus',
        data: { id: item.id }
      }).then(data => {
        this.$toast.success(data.msg)
        this.getusrBonus()
      })
    },
    async getusrInf () {
      await this.$http({
        method: 'post',
        url: 'usrInf'
      }).then(data => {
        this.userInfo = data.data
        this.active = this.userInfo.vip
      })
    },
    async getusrVip () {
      await this.$http({
        method: 'post',
        url: 'usrVip'
      }).then(data => {
        this.vipLis = data.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.privileges {
  padding: 10px 0;
  border-radius: 15px 15px 0 0;

  .group-t {
    text-align: center;
    font-size: 16px;
    color: #e0e0e0;
    margin-bottom: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    .line-left {
      width: 51px;
      height: 1px;
      background-color: hsla(0, 0%, 100%, 0.1);
      display: inline-block;
      margin-right: 18px;
    }
    .line-right {
      width: 51px;
      height: 1px;
      background-color: hsla(0, 0%, 100%, 0.1);
      display: inline-block;
      margin-left: 18px;
    }
  }
}
.vip-box {
  width: 100%;
  height: 190px;
  border-radius: 8px;
  position: relative;
  background-repeat: no-repeat;
  background-size: 102% 100%;
  .usr-vip {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    border-top-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    font-size: 12px;
    padding: 8px 14px;
  }
  .vip-icon {
    position: absolute;
    width: 130px;
    height: 130px;
    z-index: 3;
    right: 20px;
    top: -10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.vip-bg1 {
  background-image: url(../../assets/images/vip/vip_bg_1.webp);
}
.vip-bg2 {
  background-image: url(../../assets/images/vip/vip_bg_2.webp);
}
.vip-bg3 {
  background-image: url(../../assets/images/vip/vip_bg_3.webp);
}
.vip-bg4 {
  background-image: url(../../assets/images/vip/vip_bg_4.webp);
}
.vip-bg5 {
  background-image: url(../../assets/images/vip/vip_bg_5.webp);
}
.vip-bg6 {
  background-image: url(../../assets/images/vip/vip_bg_6.webp);
}
.vip-bg7 {
  background-image: url(../../assets/images/vip/vip_bg_7.webp);
}
.vip-bg8 {
  background-image: url(../../assets/images/vip/vip_bg_8.webp);
}
.vip-bg9 {
  background-image: url(../../assets/images/vip/vip_bg_9.webp);
}
.vip-bg10 {
  background-image: url(../../assets/images/vip/vip_bg_10.webp);
}

._3di95a3H {
  width: 90%;
  height: auto;
  margin: 15px auto;
}
._3di95a3H ._1HjYPvvp:first-of-type {
  border-top-right-radius: 2px;
  border-top-left-radius: 2px;
}

._3di95a3H ._1HjYPvvp {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  border: 1px solid #e9edf6;
  border-bottom: none;
  line-height: 1.5;
  overflow: hidden;
}
._3di95a3H ._1HjYPvvp p {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  color: #3f5075;
  font-size: 14px;
  min-height: 36px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding: 0 5px;
}
._3di95a3H ._1HjYPvvp {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;

  border: 1px solid #e9edf6;
  border-bottom: none;
  line-height: 1.5;
  overflow: hidden;
}
._3di95a3H ._1HjYPvvp p:nth-child(n + 2) {
  border-left: 1px solid #e9edf6;
}

._3di95a3H .returnBack p {
  min-height: 41.6px;
}
._3di95a3H ._1HjYPvvp p {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  color: #fff;
  font-size: 14px;
  min-height: 36px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding: 0 5px;
}
</style>
